module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAYAAABmvqYOAAAAM0lEQVRIx2NgYGD4jwsXJjMc+3+P4T8u/FGJ4dg7oDpcmGHU8FHDRw0fNXzU8FHDh6/hAHWQboquC5WwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/be.png
// module id = 237
// module chunks = 0